/**
 * The installable app: registers the service worker (web/public/sw.js, which only keeps an offline
 * page) in production builds. In development it would get in the way of Vite's reloads, so it stays
 * off there, and a worker left over from a production build on the same address is removed.
 */
export function registerServiceWorker({ production = import.meta.env.PROD, nav = globalThis.navigator } = {}) {
  if (!nav?.serviceWorker) return false;
  if (!production) {
    nav.serviceWorker
      .getRegistrations?.()
      .then((list) => list.forEach((r) => r.unregister()))
      .catch(() => {});
    return false;
  }
  const register = () => nav.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
  return true;
}
